import { render, staticRenderFns } from "./tableStaffSets.vue?vue&type=template&id=b6501f82&scoped=true&"
import script from "./tableStaffSets.vue?vue&type=script&lang=js&"
export * from "./tableStaffSets.vue?vue&type=script&lang=js&"
import style0 from "./tableStaffSets.vue?vue&type=style&index=0&id=b6501f82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6501f82",
  null
  
)

component.options.__file = "tableStaffSets.vue"
export default component.exports